import * as React from 'react';

import { Link } from 'react-router-dom';
import { Page, PageHero } from 'src/components/common';
import LocationTabs from './LocationTabs';

interface IProps {
	location?: any;
	match?: any;
	children?: any;
}

const LocationPage: React.FC = (props: IProps) => {

	const { organizationId, locationId, courseId } = props.match.params;

	const [ locationNameInTab, setLocationNameInTab ] = React.useState('');

	return (
		<Page title='Location details'>
			<PageHero>
				<Link to={`/admin/organizations/${organizationId}/locations`}>&lt; LOCATIONS</Link>
				<h1 className="mb-0">{locationId <= 0 ? 'New Location' : `${locationNameInTab}`}</h1>
			</PageHero>
			<LocationTabs
				className="mb-4"
				location={props.location}
				organizationId={organizationId}
				locationId={locationId}
				match={props.match}
			/>
			{props.children(setLocationNameInTab)}
		</Page>
	);

};

export default LocationPage;